<template>
  <div class="d-flex flex-column">
    <BOverlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        id="scroll"
        ref="table-scroll"
        :items="listCA"
        :fields="fieldSLATab"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        sticky-header="500px"
        class="mt-1"
      >
        <template #head(document)="data">
          <div class="d-flex flex-column">
            <span>{{ data.label }}</span>
            <small class="text-secondary font-italic">(Upload business legal documents)</small>
          </div>
        </template>
        <template #head(notes)="data">
          <div class="d-flex flex-column">
            <span>{{ data.label }}</span>
            <small class="text-secondary font-italic">(To be filled in for any missing legal documents)</small>
          </div>
        </template>
        <template #cell(name)="data">
          <div
            style="min-width: 20px !important"
            class="d-flex"
          >
            <span>
              {{ data.item.list }}
              <span class="text-danger">*</span>
            </span>
          </div>
        </template>
        <template #cell(document)="data">
          <div
            class="d-flex"
          >
            <a
              v-if="data.item.uploaded_file_path"
              :href="data.item.uploaded_file_path"
              target="_blank"
              class="text-info d-flex gap-5"
            ><img
              src="https://storage.googleapis.com/komerce/assets/icons/link-file-icon.svg"
              alt="file"
              width="20px"
            >{{ data.item.file_name }}</a>
          </div>
        </template>
        <template #cell(notes)="data">
          <div
            style="min-width: 250px; white-space: pre-wrap; word-break: break-word;"
            class="d-flex align-items-center gap-5"
          >
            {{ data.item.notes || '-' }}
          </div>
        </template>
      </BTable>
    </BOverlay>
    <hr>
    <div class="d-flex justify-content-end gap-5">
      <b-button
        variant="light"
        size="md"
        @click="rejectRequest()"
      >
        Reject
      </b-button>
      <b-button
        variant="primary"
        size="md"
        @click="approveRequest()"
      >Approve</b-button>
    </div>
    <ModalReject
      :get-ca="getCA"
      :get-detail="getDetail"
      :document-type="docType"
      :service-type="serviceType"
    />
    <ModalApprove
      :get-ca="getCA"
      :get-detail="getDetail"
      :document-type="docType"
      :service-type="serviceType"
    />
  </div>
</template>

<script>
import { openApiAxiosIns, collaboratorAxiosIns } from '@/libs/axios'
import { fieldSLATab } from '../config'
import ModalReject from './ModalRejectRequest.vue'
import ModalApprove from './ModalApproveRequest.vue'

export default {
  components: {
    ModalReject,
    ModalApprove,
  },
  props: {
    getDetail: {
      type: Function,
      required: true,
    },
    serviceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fieldSLATab,
      listCA: [
        {
          list: 'Collaboration Aggrement signed by the client',
          required: true,
          document_type: 'collaborator_agreement_file',
        },
      ],
      userId: null,
      docType: '',
      loading: false,
    }
  },
  mounted() {
    const { id } = this.$router.history.current.params
    this.userId = id
    this.getCA()
  },
  methods: {
    rejectRequest() {
      this.docType = 'CA'
      this.$bvModal.show('modal-reject-request')
    },
    approveRequest() {
      this.docType = 'CA'
      this.$bvModal.show('modal-approve-request')
    },
    async getCA() {
      this.loading = true
      const url = '/user/api/v1/admin/document-request/collaborator-agreement'
      await openApiAxiosIns.get(`${url}/${this.userId}/${this.serviceType}`)
        .then(res => {
          this.listCA = this.listCA.map((item, index) => ({
            ...item,
            ...(res.data.data[index] || {}),
          }))
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$toast_error({ message: 'Gagal Mengambil Data' })
        })
    },
  },
}
</script>
